/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
/**
 * 
 * @export
 * @interface DeviceSummary
 */
export interface DeviceSummary {
    /**
     * 
     */
    hostname: string;
    /**
     * 
     */
    latestRunStartedAt: number | null;
    /**
     * 
     */
    latestCaptureEndTimestamp: number | null;
    /**
     * 
     */
    lastSeenAt?: Date | null;
}

/**
 * Check if a given object implements the DeviceSummary interface.
 */
export function instanceOfDeviceSummary(value: object): value is DeviceSummary {
    if (!('hostname' in value) || value['hostname'] === undefined) return false;
    if ((!('latestRunStartedAt' in (value as Record<string, any>)) && !('latest_run_started_at' in (value as Record<string, any>))) || ((value as Record<string, any>)['latestRunStartedAt'] === undefined && (value as Record<string, any>)['latest_run_started_at'] === undefined)) return false;
    if ((!('latestCaptureEndTimestamp' in (value as Record<string, any>)) && !('latest_capture_end_timestamp' in (value as Record<string, any>))) || ((value as Record<string, any>)['latestCaptureEndTimestamp'] === undefined && (value as Record<string, any>)['latest_capture_end_timestamp'] === undefined)) return false;
    return true;
}

export function DeviceSummaryFromJSON(json: any): DeviceSummary {
    return DeviceSummaryFromJSONTyped(json, false);
}

export function DeviceSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeviceSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'hostname': json['hostname'],
        'latestRunStartedAt': json['latest_run_started_at'],
        'latestCaptureEndTimestamp': json['latest_capture_end_timestamp'],
        'lastSeenAt': json['last_seen_at'] === undefined ? undefined : json['last_seen_at'] === null ? null : (parseDateTime(json['last_seen_at'])),
    };
}

export function DeviceSummaryToJSON(json: any): DeviceSummary {
    return DeviceSummaryToJSONTyped(json, false);
}

export function DeviceSummaryToJSONTyped(value?: DeviceSummary | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'hostname': value['hostname'],
        'latest_run_started_at': value['latestRunStartedAt'],
        'latest_capture_end_timestamp': value['latestCaptureEndTimestamp'],
        'last_seen_at': value['lastSeenAt'] == null ? value['lastSeenAt'] : serializeDateTime(value['lastSeenAt']),
    };
}

